import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const Container = styled.article`
    background: ${({ theme }) => theme.Surface.primary};
    margin-top: 20px;
    padding: 20px 16px;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 20px 24px;
    }

    header {
        margin-bottom: 20px;
    }

    h1 {
        font-size: 24px;
        font-weight: bold;
    }
`;

// ContentContainer is used to style whatever comes in from the CMS from table layout to pretty
const ContentContainer = styled.div`
    *:not(li) {
        display: block;
    }

    table {
        border: none;
        display: block;
        font-size: 12px;
        text-align: unset;
    }

    table tbody tr {
        align-items: center;
        display: flex;
    }

    table tbody tr td {
        border: none;
        flex: 1;
    }

    // The first cell has a border applied from BAM's global imports
    table tbody tr td:first-child {
        border: none;

        // If there's an image in the first cell, make it take the whole cell
        img {
            height: 100%;
            width: 100%;
        }
    }

    // If there's a list, give some padding and add list styles since BAM removed that too
    ul {
        list-style: disc;
        padding-left: 20px;
    }

    // Instead of using paragraph tags, br's are used so let's style em
    br {
        margin-bottom: 10px;
    }
`;

export { Container, ContentContainer };
